import { render, staticRenderFns } from "./pay-bank-modal.vue?vue&type=template&id=23ea7bf0&scoped=true&"
import script from "./pay-bank-modal.vue?vue&type=script&lang=js&"
export * from "./pay-bank-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea7bf0",
  null
  
)

export default component.exports